export const TOAST_STORE_KEY = 'toast';
